import { GET } from 'utils/requests.utils'

const BASE_URL = (programId) => `/cabinet/affiliate_programs/${programId}/products`

export const fetchList = ({ programId, ...data }) => GET(BASE_URL(programId), data)
